import { useQuery } from 'react-query';
import { getCostCenterDutyHourTypes } from 'RestAPIs/admin';

export const useGetCostCenterDutyHourTypeList = () => {
  const { data } = useQuery({
    initialData: [],
    queryFn: async () => {
      const { data } = await getCostCenterDutyHourTypes();
      return data;
    },
    queryKey: ['costCenterDutyHourTypes', 'list']
  });

  return data;
};
